import "core-js/modules/es.function.name.js";
import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, createTextVNode as _createTextVNode } from "vue";
var _hoisted_1 = {
  class: "select-table"
};

var _hoisted_2 = /*#__PURE__*/_createTextVNode("删除");

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_el_table_column = _resolveComponent("el-table-column");

  var _component_el_option = _resolveComponent("el-option");

  var _component_el_select = _resolveComponent("el-select");

  var _component_el_input = _resolveComponent("el-input");

  var _component_el_button = _resolveComponent("el-button");

  var _component_el_table = _resolveComponent("el-table");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_table, {
    data: $props.tableData,
    border: "",
    style: {
      "width": "100%"
    },
    "max-height": "500px"
  }, {
    default: _withCtx(function () {
      return [_createVNode(_component_el_table_column, {
        type: "index",
        align: "center"
      }), _createVNode(_component_el_table_column, {
        prop: "defectTypes",
        label: "缺陷类型",
        align: "center"
      }, {
        default: _withCtx(function (_ref) {
          var row = _ref.row;
          return [_createVNode(_component_el_select, {
            modelValue: row.defectTypes.defect,
            "onUpdate:modelValue": function onUpdateModelValue($event) {
              return row.defectTypes.defect = $event;
            },
            class: "m-2",
            placeholder: "请选择",
            "value-key": "id",
            onChange: function onChange($event) {
              return $options.changeSelet(row);
            },
            onBlur: function onBlur($event) {
              return $options.blurSelet(row);
            },
            onFocus: function onFocus($event) {
              return $options.focusSelet(row);
            }
          }, {
            default: _withCtx(function () {
              return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.defectTypes.data, function (item) {
                return _openBlock(), _createBlock(_component_el_option, {
                  key: item.id,
                  label: item.name,
                  value: item.name
                }, null, 8, ["label", "value"]);
              }), 128))];
            }),
            _: 2
          }, 1032, ["modelValue", "onUpdate:modelValue", "onChange", "onBlur", "onFocus"])];
        }),
        _: 1
      }), _createVNode(_component_el_table_column, {
        prop: "defectLocation",
        label: "缺陷位置",
        align: "center"
      }, {
        default: _withCtx(function (_ref2) {
          var row = _ref2.row;
          return [_createVNode(_component_el_select, {
            modelValue: row.defectLocation.place,
            "onUpdate:modelValue": function onUpdateModelValue($event) {
              return row.defectLocation.place = $event;
            },
            class: "m-2",
            placeholder: "请选择",
            "value-key": "id"
          }, {
            default: _withCtx(function () {
              return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.defectLocation.data, function (item) {
                return _openBlock(), _createBlock(_component_el_option, {
                  key: item.id,
                  label: item.name,
                  value: item.name
                }, null, 8, ["label", "value"]);
              }), 128))];
            }),
            _: 2
          }, 1032, ["modelValue", "onUpdate:modelValue"])];
        }),
        _: 1
      }), _createVNode(_component_el_table_column, {
        label: "备注",
        align: "center"
      }, {
        default: _withCtx(function (_ref3) {
          var row = _ref3.row;
          return [_createVNode(_component_el_input, {
            modelValue: row.note,
            "onUpdate:modelValue": function onUpdateModelValue($event) {
              return row.note = $event;
            }
          }, null, 8, ["modelValue", "onUpdate:modelValue"])];
        }),
        _: 1
      }), _createVNode(_component_el_table_column, {
        label: "操作",
        align: "center"
      }, {
        default: _withCtx(function (_ref4) {
          var row = _ref4.row,
              $index = _ref4.$index;
          return [_createVNode(_component_el_button, {
            type: "danger",
            onClick: function onClick($event) {
              return $options.deleteDefect(row, $index);
            }
          }, {
            default: _withCtx(function () {
              return [_hoisted_2];
            }),
            _: 2
          }, 1032, ["onClick"])];
        }),
        _: 1
      })];
    }),
    _: 1
  }, 8, ["data"])]);
}